<ng-container *ngIf="currentAnnouncement$ | async as currentAnnouncement">
  <!-- Header -->
  <div class="user-wrapper" *ngIf="showHeader">
    <!-- TODO various variants -->
    <div class="category" *ngIf="!profilePicture">
      <i class="material-symbols-rounded material-icons">info</i>
    </div>

    <!-- Profile picture -->
    <i class="material-symbols-rounded profile-picture" *ngIf="profilePicture">account_circle</i>
    <div class="text-wrapper">
      <span class="owner-text">{{ currentAnnouncement.createdByUserFullName }}</span>
      <span class="published-text">
        <span class="unread-dot" *ngIf="isRead === false"></span>
        {{ currentAnnouncement.created | date : 'd. M.' }} v {{ currentAnnouncement.created | date : 'hh:mm' }}
      </span>
    </div>

    <!-- Action buttons (shown only when inputs are provided) -->
    <div class="action-buttons" *ngIf="isStarred !== null || isRead !== null">
<!--      <button *ngIf="isRead !== null" mat-icon-button class="action-btn" (click)="$event.stopPropagation(); toggleRead.emit()">-->
<!--        <i class="material-symbols-rounded material-icons" [class.active]="isRead">{{-->
<!--          isRead ? 'mark_email_read' : 'mark_email_unread'-->
<!--        }}</i>-->
<!--      </button>-->
<!--      <button *ngIf="isStarred !== null" mat-icon-button class="action-btn" (click)="$event.stopPropagation(); toggleStarred.emit()">-->
<!--        <i class="material-symbols-rounded material-icons" [class.active]="isStarred">{{ isStarred ? 'star' : 'star_border' }}</i>-->
<!--      </button>-->
    </div>
  </div>

  <!-- Text -->
  <div class="content-text-wrapper pt-2" *transloco="let t">
    <h3 class="content-title">{{ currentAnnouncement.title }}</h3>
    <div class="more-wrapper" *ngIf="currentAnnouncement.content">
      <p
        #text
        class="text"
        [ngClass]="{
          expanded: this.textExpanded$ | async
        }"
        [innerHTML]="currentAnnouncement.content"
        (click)="toggleExpander('body')"
      ></p>
      <span *ngIf="(showTextExpander$ | async) && (textExpanded$ | async) === false" class="show-more" (click)="toggleExpander('toggle')">
        {{ t('shared/showMore') }}
      </span>
      <span *ngIf="(textExpanded$ | async) === true && !this.expandedText" class="show-more" (click)="toggleExpander('toggle')">
        {{ t('shared/showLess') }}
      </span>
    </div>
  </div>

  <!-- Attachmnets -->
  <div class="attachment-wrapper">
    <div class="attachment" (click)="downloadAttachment(attachment.file)" *ngFor="let attachment of currentAnnouncement.documents">
      <i class="material-symbols-rounded material-icons-outlined">attachment</i>
      <span>{{ attachment.fileName }}</span>
    </div>
  </div>

  <!-- Images/Videos -->
  <div
    *ngIf="announcementMedia$ | async as media"
    [id]="'img-gallery-' + currentAnnouncement.id"
    class="img-wrapper pswp-gallery"
    [ngClass]="{
      'one-image': media.length === 1,
      'two-images': media.length === 2,
      'more-images': media.length > 2
    }"
  >
    <ng-container *ngFor="let img of media; let i = index">
      <!-- First 2 medias -->
      <ng-container *ngIf="i === 0 || i === 1">
        <a
          [href]="media[i].file"
          target="_blank"
          class="file-link"
          [attr.data-pswp-type]="media[i].fileType"
          [attr.data-sources]="getJsonSources(media[i])"
        >
          <ng-container *ngTemplateOutlet="mediaShow; context: { media: media[i] }"></ng-container>
        </a>
      </ng-container>
      <!-- Third media -->
      <ng-container *ngIf="i === 2">
        <a
          [href]="media[i].file"
          target="_blank"
          *ngIf="media.length >= 3"
          class="more-img-wrapper"
          [attr.data-pswp-type]="media[i].fileType"
          [attr.data-sources]="getJsonSources(media[i])"
        >
          <ng-container *ngTemplateOutlet="mediaShow; context: { media: media[i] }"></ng-container>
          <ng-container *ngIf="media.length >= 4">
            <div class="more-img"></div>
            <span>+{{ media.length - 3 }}</span>
          </ng-container>
        </a>
      </ng-container>
      <!-- All next -->
      <ng-container *ngIf="i >= 3">
        <a
          [href]="media[i].file"
          target="_blank"
          class="hidden-img"
          [attr.data-pswp-type]="media[i].fileType"
          [attr.data-sources]="getJsonSources(media[i])"
        >
          <ng-container *ngTemplateOutlet="mediaShow; context: { media: media[i] }"></ng-container>
        </a>
      </ng-container>
    </ng-container>
  </div>
</ng-container>

<ng-template #mediaShow let-media="media">
  <ng-container *ngIf="media.fileType === 'video'">
    <video muted preload="none" [poster]="media.thumbnail">
      <source [src]="media.convertedWebm" type="video/webm" />
      <source [src]="media.convertedMp4" type="video/mp4" />
      <source [src]="media.file" />
    </video>
    <i class="material-symbols-rounded material-icons video-play">play_circle</i>
  </ng-container>
  <ng-container *ngIf="media.fileType === 'image'">
    <img [src]="media.thumbnail || media.file" loading="lazy" alt="" />
  </ng-container>
</ng-template>
